import React from 'react';

const OpportunitiesPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default OpportunitiesPage;
